export default __webpack_public_path__ + "static/media/submitFlowImg.94ed07ee.svg";